module.exports = __webpack_public_path__ + "img/dark_logo.e518c4d1.png";